import type { Components } from '@mui/material/styles';

export default function MuiStack(): Components['MuiStack'] {
  return {
    defaultProps: {
      useFlexGap: true,
    },
    variants: [
      {
        props: { 'data-full-width': true },
        style: {
          width: '100%',
        },
      },
    ],
  };
}
